import React from 'react'

const IconText = ({color}) => {
    return (
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M79 90C77 96 71.5 100 65 100H15C6.5 100 0 93.5 0 85V80H61C63 86 68.5 90 75 90H79ZM85 0C93.5 0 100 6.5 100 15V16C100 18.2091 98.2091 20 96 20H94C91.7909 20 90 18.2091 90 16V15C90 12 88 10 85 10C82 10 80 12 80 15V80H75C72 80 70 78 70 75V70H15V15C15 6.5 21.5 0 30 0H85ZM30 20V30H65V20H30ZM30 40V50H60V40H30Z" fill={color} />
        </svg>
    )
}

export default IconText
